/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
import { apiPost } from 'utils'
import { IArticleDetail, IArticleItem, IArticleRelease, IArticleRequest } from 'model'
import { IdList, PaginationResponse, XhhyBaseType, XhhyResponse } from 'Xhhy-common/common'

/**
 * 获取文章列表
 * @param params
 */
export const apiArticleList = async (params: IArticleRequest) => {
  return await apiPost<IArticleRequest, PaginationResponse<IArticleItem>>(`/ticpocapi/article/list`, params)
}

/**
 * 保存文章
 * @param params
 */
export const apiSaveArticle = async (params: IArticleRelease) => {
  return await apiPost<IArticleRelease, XhhyResponse>(`/ticpocapi/article/save`, params)
}

/**
*  编辑保存Article
* @param params
*/
export const apiEditArticle = async (params: IArticleRelease) => {
  return await apiPost<IArticleRelease, XhhyResponse>(`/ticpocapi/article/update`, params)
}

/**
*  编辑-预览并提交
* @param params
*/
export const apiUpdatesubmitArticle = async (params: IArticleRelease) => {
  return await apiPost<IArticleRelease, XhhyResponse>(`/ticpocapi/article/updatesubmit`, params)
}

/**
*  拉取Article明细
* @param params
*/
export const apiArticleDetail = async (params: XhhyBaseType) => {
  return await apiPost<XhhyBaseType, IArticleDetail>(`/ticpocapi/article/detail`, params)
}

/**
*  拉取编辑详情
* @param params
*/
export const apiArticleInfo = async (params: XhhyBaseType) => {
  return await apiPost<XhhyBaseType, IArticleDetail>(`/ticpocapi/article/selectEditDetailInfo`, params)
}

/**
* 删除Article
* @param params
*/
export const apiDeleteArticle = async (params: XhhyBaseType) => {
  return await apiPost<XhhyBaseType, XhhyResponse>(`/ticpocapi/article/delete`, params)
}

/**
* 预览后提交
* @param params
*/
export const apiArticleRelease = async (params: IArticleRelease) => {
  return await apiPost<IArticleRelease, XhhyResponse>(`/ticpocapi/article/release`, params)
}

